export default __webpack_public_path__ + "static/media/success4.png";